import { RootState } from "@src/store";
import { selectedExperience } from "@src/store/slices/experiences";
import { Experience } from "@src/store/slices/experiences/types";
import { getCurrencyConfiguration } from "@src/store/slices/organization/selectors/getCurrencyConfiguration";

export const isMultiCurrencyExperience = (state: RootState): boolean => {
  const experience = selectedExperience(state);
  if (!experience) return false;

  return isExperienceMultiCurrencyExperience(experience)(state);
};

export const isExperienceMultiCurrencyExperience =
  (experience: Experience) => (state: RootState) => {
    const config = getCurrencyConfiguration(state);
    const experienceCode = experience?.currency?.code;
    const configCode = config?.code ?? "USD";
    return (experienceCode && experienceCode !== configCode) || false;
  };
